import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#707070",
    viewBox: "0 0 81 81",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="40.398" cy="40.481" r="39.5" stroke="inherit" stroke-width="inherit" /> <path stroke="inherit" stroke-width="2" d="M33.32 27.42a4.067 4.067 0 11-8.133 0 4.067 4.067 0 018.133 0zM55.599 27.42a4.067 4.067 0 11-8.134 0 4.067 4.067 0 018.134 0zM37.17 43.104v14.505H21.348V42.104a6.129 6.129 0 016.129-6.13h3.552a6.128 6.128 0 016.128 6.13v1h.014zM59.449 43.104v14.505H43.626V42.104a6.129 6.129 0 016.13-6.13h3.551a6.128 6.128 0 016.128 6.13v1h.014z"/>' }
  })
);